module.exports = __webpack_public_path__ + "static/media/icn_contact.5fc595ba.svg";